import React, { useState } from "react";
import "../../cssfiles/loginpage.css";
import "../../cssfiles/homepage.css";
import Loginpageleftimage from "../../pages/Loginpageleftimage.js";
import brandlogo from "../../images/LKLogo.png";
import { useNavigate } from "react-router-dom";
import {
  FormControl,
  Input,
  Typography,
  IconButton,
  InputAdornment
} from "@mui/material";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import { ChangePasswordAPI } from "../../Restclient/datacollection";
import CustomDialogBox from "../CommonComponents/CustomDialogBox.jsx";

export default function ChangePassword() {
  const navigate = useNavigate();
  const [openDialog, setOpenDialog] = useState(false);
  const [dialogMessage, setDialogMessage] = useState("");
  const [dialogType, setDialogType] = useState("Info");
  const [email, setEmail] = useState(sessionStorage.getItem("userEmail") || "");
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [isExpiredPasswordReset, setIsExpiredPasswordReset] = useState(false);
  const [isFirstLogin, setIsFirstLogin] = useState(false);

  // Check if this is an expired password reset (has temp token) or first login
  React.useEffect(() => {
    const tempToken = sessionStorage.getItem("tempPasswordChangeToken");
    const firstLogin = sessionStorage.getItem("isFirstLogin");
    
    if (tempToken) {
      setIsExpiredPasswordReset(true);
    }
    
    if (firstLogin === "true") {
      setIsFirstLogin(true);
    }
  }, []);

  const handleCloseDialog = () => {
    setOpenDialog(false);
    if (dialogType === "Success") {
      // Clear session storage
      sessionStorage.clear();
      navigate("/");
    }
  };

  const handleConfirmDialog = () => {
    setOpenDialog(false);
    if (dialogType === "Success") {
      sessionStorage.clear();
      navigate("/");
    }
  };

  const validatePassword = (password) => {
    // Password must be at least 8 characters with uppercase, lowercase, number, and special character
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
    return passwordRegex.test(password);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMsg("");

    // Validation for expired password reset or first login (no current password needed)
    if (isExpiredPasswordReset || isFirstLogin) {
      if (!email || !newPassword || !confirmPassword) {
        setErrorMsg("Email, new password, and confirm password are required");
        return;
      }
    } else {
      // Normal password change
      if (!email || !currentPassword || !newPassword || !confirmPassword) {
        setErrorMsg("All fields are required");
        return;
      }

      if (currentPassword === newPassword) {
        setErrorMsg("New password must be different from current password");
        return;
      }
    }

    if (newPassword !== confirmPassword) {
      setErrorMsg("New password and confirm password do not match");
      return;
    }

    if (!validatePassword(newPassword)) {
      setErrorMsg("Password must be at least 8 characters long and contain uppercase, lowercase, number, and special character");
      return;
    }

    // Get temp token if exists
    const tempToken = sessionStorage.getItem("tempPasswordChangeToken");

    // Call API to change password
    ChangePasswordAPI(
      email, 
      (isExpiredPasswordReset || isFirstLogin) ? null : currentPassword, 
      newPassword, 
      tempToken,
      (response) => {
        if (response.error || !response.success) {
          setDialogMessage(response.message || "Error changing password. Please try again.");
          setDialogType("Error");
        } else {
          setDialogMessage(
            isFirstLogin 
              ? "Password set successfully! Please login with your new password."
              : isExpiredPasswordReset
              ? "Password reset successfully! Please login with your new password."
              : "Password changed successfully! Please login with your new password."
          );
          setDialogType("Success");
        }
        setOpenDialog(true);
      }
    );
  };

  const handleCancel = () => {
    // Clear temp token if exists
    sessionStorage.removeItem("tempPasswordChangeToken");
    sessionStorage.removeItem("userEmail");
    
    // Check if user is already logged in
    const token = sessionStorage.getItem("Token");
    if (token) {
      navigate("/home");
    } else {
      navigate("/");
    }
  };

  return (
    <div className="container">
      <div className="left-side">
        <Loginpageleftimage />
      </div>
      <div className="right-side">
        <div style={{ display: "flex", flexDirection: "row" }}>
          <div style={{ flexGrow: 1 }}></div>
          <div className="formcompanylogo">
            <img
              src={brandlogo}
              alt="placeholder"
              style={{ marginLeft: "17px", height: "55px", width: "150px" }}
            />
          </div>
        </div>
        <div style={{ display: "flex", flexDirection: "row", marginTop: "50px" }}>
          <div style={{ flexGrow: 1 }}></div>
          <div className="loginarea">
            <div className="loginSignup">
              <Typography
                className="signintext"
                style={{
                  fontSize: "30px",
                  fontWeight: 700,
                  marginRight: "135px",
                }}
              >
                {isFirstLogin ? "Set Your Password" : "Change Password"}
              </Typography>
            </div>
            
            {/* Warning message for first login */}
            {isFirstLogin && (
              <div style={{
                backgroundColor: "#d1ecf1",
                border: "1px solid #17a2b8",
                borderRadius: "5px",
                padding: "10px",
                marginTop: "15px",
                marginBottom: "15px",
              }}>
                <Typography style={{ color: "#0c5460", fontSize: "14px" }}>
                  🔐 Welcome! Please set a new password for your account.
                </Typography>
              </div>
            )}
            
            {/* Warning message for expired password */}
            {isExpiredPasswordReset && (
              <div style={{
                backgroundColor: "#fff3cd",
                border: "1px solid #ffc107",
                borderRadius: "5px",
                padding: "10px",
                marginTop: "15px",
                marginBottom: "15px",
              }}>
                <Typography style={{ color: "#856404", fontSize: "14px" }}>
                  ⚠️ Your password has expired. Please set a new password to continue.
                </Typography>
              </div>
            )}
            
            <form onSubmit={handleSubmit}>
              {/* Email Field */}
              <div style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                marginTop: "25px",
                marginBottom: "15px",
              }}>
                <div style={{
                  display: "flex",
                  textAlign: "start",
                  marginBottom: "10px",
                  fontSize: "18px",
                  fontWeight: "400",
                  color: "#3C3C3C"
                }}>
                  <label htmlFor="email">
                    Email ID <span style={{ color: "red" }}>*</span>
                  </label>
                </div>
                <FormControl fullWidth sx={{ width: "358px" }} variant="standard">
                  <Input
                    id="email"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Email"
                    disabled={true}
                    sx={{
                    //   border: "1px solid #3C3C3C",
                    //   borderRadius: "5px",
                      paddingLeft: "10px",
                      height: "35px",
                    }}
                    //disableUnderline
                  />
                </FormControl>
              </div>

              {/* Current Password Field - Only show for normal password change */}
              {!isExpiredPasswordReset && !isFirstLogin && (
                <div style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  marginBottom: "15px",
                }}>
                  <div style={{
                    display: "flex",
                    textAlign: "start",
                    marginBottom: "10px",
                    fontSize: "18px",
                    fontWeight: "400",
                    color: "#3C3C3C"
                  }}>
                    <label htmlFor="currentPassword">
                      Current Password <span style={{ color: "red" }}>*</span>
                    </label>
                  </div>
                  <FormControl fullWidth sx={{ width: "358px" }} variant="standard">
                    <Input
                      id="currentPassword"
                      type={showCurrentPassword ? "text" : "password"}
                      value={currentPassword}
                      onChange={(e) => setCurrentPassword(e.target.value)}
                      placeholder="Current Password"
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            onClick={() => setShowCurrentPassword(!showCurrentPassword)}
                            edge="end"
                          >
                            {showCurrentPassword ? <VisibilityOutlinedIcon /> : <VisibilityOffOutlinedIcon />}
                          </IconButton>
                        </InputAdornment>
                      }
                    sx={{
                    //   border: "1px solid #3C3C3C",
                    //   borderRadius: "5px",
                      paddingLeft: "10px",
                      height: "35px",
                    }}
                    // disableUnderline
                  />
                </FormControl>
                </div>
              )}

              {/* New Password Field */}
              <div style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                marginBottom: "15px",
              }}>
                <div style={{
                  display: "flex",
                  textAlign: "start",
                  marginBottom: "10px",
                  fontSize: "18px",
                  fontWeight: "400",
                  color: "#3C3C3C"
                }}>
                  <label htmlFor="newPassword">
                    Enter New Password <span style={{ color: "red" }}>*</span>
                  </label>
                </div>
                <FormControl fullWidth sx={{ width: "358px" }} variant="standard">
                  <Input
                    id="newPassword"
                    type={showNewPassword ? "text" : "password"}
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    placeholder="New Password"
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => setShowNewPassword(!showNewPassword)}
                          edge="end"
                        >
                          {showNewPassword ? <VisibilityOutlinedIcon /> : <VisibilityOffOutlinedIcon />}
                        </IconButton>
                      </InputAdornment>
                    }
                    sx={{
                    //   border: "1px solid #3C3C3C",
                    //   borderRadius: "5px",
                      paddingLeft: "10px",
                      height: "35px",
                    }}
                    // disableUnderline
                  />
                </FormControl>
                <Typography variant="caption" style={{ color: "#7E7E7E", marginTop: "5px" }}>
                  Min 8 characters with uppercase, lowercase, number & special character
                </Typography>
              </div>

              {/* Confirm Password Field */}
              <div style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                marginBottom: "15px",
              }}>
                <div style={{
                  display: "flex",
                  textAlign: "start",
                  marginBottom: "10px",
                  fontSize: "18px",
                  fontWeight: "400",
                  color: "#3C3C3C"
                }}>
                  <label htmlFor="confirmPassword">
                    Confirm New Password <span style={{ color: "red" }}>*</span>
                  </label>
                </div>
                <FormControl fullWidth sx={{ width: "358px" }} variant="standard">
                  <Input
                    id="confirmPassword"
                    type={showConfirmPassword ? "text" : "password"}
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    placeholder="Confirm New Password"
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                          edge="end"
                        >
                          {showConfirmPassword ? <VisibilityOutlinedIcon /> : <VisibilityOffOutlinedIcon />}
                        </IconButton>
                      </InputAdornment>
                    }
                    sx={{
                    //   border: "1px solid #3C3C3C",
                    //   borderRadius: "5px",
                      paddingLeft: "10px",
                      height: "35px",
                    }}
                    // disableUnderline
                  />
                </FormControl>
              </div>

              {/* Error Message */}
              {errorMsg && (
                <div style={{ marginTop: "10px", marginBottom: "10px" }}>
                  <Typography style={{ color: "red", fontSize: "14px" }}>
                    {errorMsg}
                  </Typography>
                </div>
              )}

              {/* Buttons */}
              <div style={{ display: "flex", gap: "10px", width: "100%", marginTop: "20px" }}>
                <button
                  type="submit"
                  style={{
                    width: "50%",
                    height: "35px",
                    fontSize: "18px",
                    backgroundColor: "#005C8E",
                    color: "#FFFFFF",
                    cursor: "pointer",
                    border: "none",
                    borderRadius: "25px",
                  }}
                >
                  Change Password
                </button>
                <button
                  type="button"
                  onClick={handleCancel}
                  style={{
                    width: "50%",
                    height: "35px",
                    fontSize: "18px",
                    backgroundColor: "#7E7E7E",
                    color: "#FFFFFF",
                    cursor: "pointer",
                    border: "none",
                    borderRadius: "25px",
                  }}
                >
                  Cancel
                </button>
              </div>
            </form>

            <div className="privacy-text" style={{ marginTop: "20px" }}>
              <Typography variant="body2" style={{
                color: "#7E7E7E",
                fontSize: "13px",
                textAlign: 'center',
              }}>
                The content of this website is copyrighted. All rights reserved
              </Typography>
            </div>
          </div>
          <div style={{ flexGrow: 1 }}></div>
        </div>
      </div>

      {/* Dialog Box */}
      <CustomDialogBox
        openDialog={openDialog}
        dialogTitle={dialogType}
        dialogText={dialogMessage}
        handleCloseDialog={handleCloseDialog}
        handleConfirmDialog={handleConfirmDialog}
        confirmText="Ok"
        cancelText="Cancel"
        type={dialogType}
      />
    </div>
  );
}
